<section id="dacIntro-id" class="dac-intro">
  <div class="box">
    <div class="box-image">
      <div class="image-container">
        <picture>
          <source
            srcset="
              https://flowaccountcdn.com/new_landing/image/event/digital-accounting-conference/intro/Banner_Landing_DAC.webp
            "
            type="image/webp"
          />
          <img
            src="https://flowaccountcdn.com/new_landing/image/event/digital-accounting-conference/intro/Banner_Landing_DAC.png"
            class="element-image"
            [alt]="'EVENT.DIGITAL_ACCOUNTING_CONFERENCE.INTRO.TITLE' | translate"
          />
        </picture>
      </div>
    </div>

    <ng-container *ngIf="(serviceList$ | async)?.length">
      <ng-container *ngFor="let item of serviceList$ | async">
        <div class="box-content" [innerHTML]="item.data.html.iv"></div>
      </ng-container>
    </ng-container>
  </div>
</section>
